import {InfoEntry, TFaqSection, TMetaData} from '.'

const MetaData: TMetaData = {
  title: 'Free Online Games to Play Without Downloading | Gamezop',
  desc: 'Play free online games without downloading them on Gamezop. 200+ free games to play, including action, adventure, arcade, puzzle, racing, and more. Play now!',
}

const InfoData: InfoEntry[] = [
  {
    tag: 'h1',
    title: 'Free Online Games to Play Without Downloading',
    body: {
      text: [
        `Gamezop offers the best free online games to play without downloading, choose your favorite game from list of games and play within seconds. We have over 200+ most popular free games across categories like action, adventure, arcade, puzzle, racing, and more. Whether you’re looking for mobile, PC or iOS games we have the best free games for you. When bored, Gamezop has endless options to keep you entertained. Take on exciting challenges—build defenses to stop demons, shoot down targets, or jump over obstacles. Enjoy a wide variety of exciting games, including Kingdom Fight, City Cricket, Fruity Fiesta, and more! Gamezop offers fun and engaging games suitable for all ages—kids, adults, and seniors alike.`,
        `You don't need high-end devices to play these free games. You can play our games for free without installing and downloading them because our games only need a browser and internet connection, which works on every device, including desktops, laptops, Chromebooks, smartphones, tablets, and more.`,
      ],
      list: [],
    },
    links: {
      'Kingdom Fight': {
        type: 'game',
        name: 'Kingdom Fight',
        code: 'SyfxJ3a75Cr',
      },
      'City Cricket': {
        type: 'game',
        name: 'City Cricket',
        code: 'HJP4afkvqJQ',
      },
      'Fruity Fiesta': {
        type: 'game',
        name: 'Fruity Fiesta',
        code: 'mKZZW9NXW',
      },
    },
  },
  {
    tag: 'h2',
    title: 'What are the best free online games?',
    body: {
      text: [],
      list: [
        {
          name: 'Bubble Wipeout',
          code: 'H1AN6fkwqJ7',
          type: 'game',
        },
        {
          name: 'Mahjong At Home: Scandinavian Edition',
          code: 'JVhRZNwly',
          type: 'game',
        },
        {
          name: 'Merge Mania',
          code: 'hfPOimYqY',
          type: 'game',
        },
        {
          name: 'Chef Tycoon',
          code: 'xqO4nZ6Kt',
          type: 'game',
        },
        {
          name: 'Cyberfusion',
          code: 'HJXei0j',
          type: 'game',
        },
        {
          name: 'Mafia Billiard Tricks',
          code: 'SkkV6MJD51Q',
          type: 'game',
        },
        {
          name: 'Spider Solitaire',
          code: 'B1MfIa4QCg',
          type: 'game',
        },
        {
          name: 'Basket Champs',
          code: 'S1_V6GyP5ym',
          type: 'game',
        },
        {
          name: 'Algerian Solitaire',
          code: 'rJu76zkD917',
          type: 'game',
        },
        {
          name: 'Dragon Annihilation',
          code: 'PdIZyZNAe',
          type: 'game',
        },
      ],
    },
    initalState: 'initial_open',
  },
  {
    tag: 'h2',
    title: 'What are free online games to play with friends?',
    body: {
      text: [],
      list: [
        {
          name: 'Ludo with Friends',
          code: 'SkhljT2fdgb',
          type: 'game',
        },
        {
          name: 'ZUNO',
          code: 'ByQxJnp7qRB',
          type: 'game',
        },
        {
          name: 'Tic Tac Toe',
          code: 'H1WmafkP9JQ',
          type: 'game',
        },
        {
          name: 'Ludo Dash',
          code: 'SJRX12TXcRH',
          type: 'game',
        },
      ],
    },
    initalState: 'initial_open',
  },
  {
    tag: 'h2',
    title: 'What are the most popular online games genres?',
    body: {
      text: [],
      list: [
        {
          name: 'Crazy games',
          nameEn: 'Crazy games',
          code: '10',
          type: 'tag',
        },
        {
          name: 'Board games',
          nameEn: 'Board games',
          code: '11',
          type: 'tag',
        },
        {
          name: 'Adventure games',
          nameEn: 'Adventure games',
          code: '14',
          type: 'tag',
        },
        {
          name: 'Puzzle games',
          nameEn: 'Puzzle games',
          code: '8',
          type: 'tag',
        },
        {
          name: 'Shooting games',
          nameEn: 'Shooting games',
          code: '2',
          type: 'tag',
        },
      ],
    },
    initalState: 'initial_open',
  },
  {
    tag: 'h2',
    title: 'What is Gamezop?',
    body: {
      text: [
        `Gamezop is a plug-and-play gaming platform that enables apps and websites to integrate casual games seamlessly, enhancing user engagement. Beyond gaming, Gamezop operates multiple specialized platforms: Quizzop for interactive trivia and quizzes, Astrozop for astrology insights and predictions, Criczop for live cricket scores and updates, and Feedzop for curated news aggregation. Together, these platforms provide a diverse suite of content solutions that cater to various audience interests. Visit business.gamezop.com for more details.`,
        `With over 8,000 integrations across more than 70 countries, Gamezop and its associated platforms are trusted by global brands like Amazon, Samsung Internet, Snap, Tata Play, AccuWeather, and Paytm. These solutions not only drive user engagement but also unlock new revenue opportunities. Integration is quick, taking just 30 minutes, and empowers apps and websites with engaging content spanning games, quizzes, astrology, cricket, and news.`,
      ],
      list: [],
    },
    links: {
      'business.gamezop.com': 'https://business.gamezop.com',
    },
    initalState: 'initial_open',
  },
]

const FaqData: TFaqSection = {
  headTag: 'h2',
  headTitle: 'FAQs',
  faqs: [
    {
      tag: 'h3',
      title: 'Can I play free games without installing?',
      body: ['Yes, you can play free games without installing or downloading them.'],
    },
    {
      tag: 'h3',
      title: 'Do I need to sign up to play?',
      body: [
        'No, you don’t need to sign up to play games on Gamezop.com . You can start playing instantly without any registration.',
      ],
      links: {
        'Gamezop.com': 'https://www.gamezop.com',
      },
    },
    {
      tag: 'h3',
      title: 'Is it safe to play online games​?',
      body: [
        'Yes, it’s safe to play online games on trusted platforms like Gamezop. Our games don’t need downloads, minimizing malware risks. We focus on user security and ensure a safe gaming experience without affecting your privacy or device safety.',
      ],
    },
    {
      tag: 'h3',
      title: 'Are free games really free?',
      body: [
        'Yes, free games are genuinely free to play on Gamezop. However, these games may display ads to support the platform.',
      ],
    },
    {
      tag: 'h3',
      title: 'Are there free games for seniors online?',
      body: [
        'Yes, we have free games for seniors that you can play online, including Sudoku Classic, Solitaire Gold, Chess Grandmaster, and more.',
      ],
      links: {
        'Sudoku Classic': {
          type: 'game',
          name: 'Sudoku Classic',
          code: 'SJgx126Qc0H',
        },
        'Solitaire Gold': {
          type: 'game',
          name: 'Solitaire Gold',
          code: 'rkPlk2T7qAr',
        },
        'Chess Grandmaster': {
          type: 'game',
          name: 'Chess Grandmaster',
          code: 'rkAXTzkD5kX',
        },
      },
    },
  ],
}

export default {
  meta: MetaData,
  info: InfoData,
  faq: FaqData,
}
